export default __webpack_public_path__ + "static/media/GP.db62f2f8.svg";